import avatar1Asset from "simplydo/assets/images/avatars/1.png";
import avatar2Asset from "simplydo/assets/images/avatars/2.png";
import avatar3Asset from "simplydo/assets/images/avatars/3.png";
import avatar4Asset from "simplydo/assets/images/avatars/4.png";
import avatar5Asset from "simplydo/assets/images/avatars/5.png";
import avatar6Asset from "simplydo/assets/images/avatars/6.png";
import avatar7Asset from "simplydo/assets/images/avatars/7.png";
import avatar8Asset from "simplydo/assets/images/avatars/8.png";
import avatarDefaultAsset from "simplydo/assets/images/avatars/default.png";
import challengeBannerAsset from "simplydo/assets/images/challengeBanner.jpg";
import defaultsOrgLogoAsset from "simplydo/assets/images/defaults/org-logo.png";
import defaultsProfileLogoAsset from "simplydo/assets/images/defaults/profile-logo.png";
import format3isAsset from "simplydo/assets/images/format_3is.png";
import formatScratchAsset from "simplydo/assets/images/format_scratch.png";
import groupCoverAsset from "simplydo/assets/images/groupCoverImage.png";
import iconAsset from "simplydo/assets/images/icon.png";
import ideaAsset from "simplydo/assets/images/idea.png";
import logoDarkAsset from "simplydo/assets/images/logo_dark.png";
import logoLightAsset from "simplydo/assets/images/logo_light.png";

const ASSETS: Record<string, string> = {
  "images/avatars/1.png": avatar1Asset,
  "images/avatars/2.png": avatar2Asset,
  "images/avatars/3.png": avatar3Asset,
  "images/avatars/4.png": avatar4Asset,
  "images/avatars/5.png": avatar5Asset,
  "images/avatars/6.png": avatar6Asset,
  "images/avatars/7.png": avatar7Asset,
  "images/avatars/8.png": avatar8Asset,
  "images/avatars/default.png": avatarDefaultAsset,
  "images/challengeBanner.jpg": challengeBannerAsset,
  "images/defaults/org-logo.png": defaultsOrgLogoAsset,
  "images/defaults/profile-logo.png": defaultsProfileLogoAsset,
  "images/format_3is.png": format3isAsset,
  "images/format_scratch.png": formatScratchAsset,
  "images/groupCoverImage.png": groupCoverAsset,
  "images/icon.png": iconAsset,
  "images/idea.png": ideaAsset,
  "images/logo_dark.png": logoDarkAsset,
  "images/logo_light.png": logoLightAsset,
};

export const getAssetUrl = (path: string) => {
  const asset = ASSETS[path];
  if (asset) return asset;
  if (import.meta.env.DEV) {
    console.warn(
      `Asset "${path}" is not bundled, falling back to the web-hosted /static copy`,
    );
  }
  return `/static/${path}`;
};
